import React, {useCallback, useEffect, useState} from 'react'
import {Modal} from '../../../components/library/modal/modal'
import {
  PermissionAction,
  PermissionResource
} from '../../../data/workbench-api/generated/types'
import {useEnvironment} from '../../../environment'
import {
  CommonVariableComponentProps,
  CardVariableForm
} from './card-variable-form'
import {Loader} from '../../../components/loader'

interface VariableModalProps extends CommonVariableComponentProps {
  order?: 'up' | 'down'
  onChanged?: (changed: boolean) => void
  providerId?: string
}

export const VariableModal = ({
  editing,
  order,
  onChanged,
  providerId,
  ...props
}: VariableModalProps) => {
  const [dirty, setDirty] = useState<boolean>(false)
  const [orderState, setOrderState] = useState(order)
  const {environment} = useEnvironment()

  const readOnly = !environment?.hasPermission(
    PermissionResource.CardTemplate,
    PermissionAction.Edit
  )
  const wrappedHandleClose = useCallback(() => {
    if (
      !dirty ||
      readOnly ||
      confirm(
        'You have unsaved changes - are you sure you want to discard them?'
      )
    ) {
      props.onCancel()
    }
  }, [props, dirty, readOnly])

  useEffect(() => {
    if (!readOnly && onChanged) {
      onChanged(dirty)
    }
  }, [dirty, onChanged, readOnly])

  if (!environment) return <Loader />

  return (
    <Modal
      order={orderState}
      style={{maxWidth: '500px'}}
      title={editing ? 'Edit variable' : 'New variable'}
      handleClose={wrappedHandleClose}
    >
      <CardVariableForm
        environment={environment}
        editing={editing}
        setDirty={setDirty}
        setOrder={setOrderState}
        handleClose={wrappedHandleClose}
        readOnly={readOnly}
        providerId={providerId}
        {...props}
      />
    </Modal>
  )
}
